module.exports = __webpack_public_path__ + "img/09.e3ca6d5c.png";